module.exports = __webpack_public_path__ + "img/big2.1a9f9253.jpg";